<template>
  <div style="width:100%">
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-list two-line>
            <template v-for="(item, index) in event_list">
              <v-subheader
                v-if="item.header"
                :key="index"
              >
                {{ item.header }}
              </v-subheader>

              <v-divider
                v-else-if="item.divider"
                :key="index"
                :inset="item.inset"
              ></v-divider>

              <v-list-tile
                v-else
                :key="index"
                avatar
                ripple
                @click="goEventDetail(item)"
              >
                <v-list-tile-avatar>
                  <i class="material-icons" style="font-size:35px">{{item.avatar}}</i>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title v-html="item.title" style="white-space:normal; height:fit-content;"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'user-events',
  data () {
    return {
    }
  },
  methods: {
    goEventDetail (event) {
      this.$router.push({name: 'admin-event-detail', params: {event: event.data}})
    }
  },
  computed: {
    event_list() {
      let event_list = []
      let events = this.$store.getters.getAdminEvents
      events.forEach((event, idx) => {
        event_list.push({ header: 'Created: ' + moment(event.createdAt).format('MMMM Do YYYY')})
        event_list.push({
          avatar: 'event',
          title: event.title || '* No Title Entered *',
          subtitle: 'Event Owner: ' + event.owner,
          data: event
        })

        if (idx != events.length -1)
          event_list.push({ divider: true, inset: true })
      });

      return event_list
    }
  }
}
</script>

<style scoped>
</style>
